import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';
import { locale, messages } from './lang';
import {
  defineCustomElements,
  applyPolyfills,
} from '@swisscom/sdx/dist/js/webcomponents/loader';
import '@swisscom/sdx/dist/css/sdx.css';
import '@swisscom/sdx/dist/css/sdx.min.css';

Vue.use(VueI18n);

const lang = localStorage.getItem('lang');

//Creates I18n instance with options
export const i18n = new VueI18n({
  fallbackLocale: 'de',
  locale: lang === null || !lang ? locale : lang, //sets local language
  messages,
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/sdx-\w*/];

applyPolyfills().then(() => {
  defineCustomElements();
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
